import { ConditionsList } from './ApplicantConditions.StyledComponents';
import { Condition } from './ApplicantConditions.types';
import { ConditionCard } from './ConditionCard';

interface ConditionsAccordionProps {
    conditions: Condition[];
    isDeleted?: boolean;
    highlightConditionId?: string | null;
    expandedConditionId?: string | null;
    renderHeader: (condition: Condition, onOpen: () => void, isOpen: boolean) => React.ReactNode;
    renderContent: (condition: Condition) => React.ReactNode;
    onFileDrop?: (condition: Condition, files: File[]) => void;
}

export const ConditionsAccordion = ({
    conditions,
    isDeleted,
    highlightConditionId,
    expandedConditionId,
    renderHeader,
    renderContent,
    onFileDrop,
}: ConditionsAccordionProps) => {
    const focusId = highlightConditionId ?? null;
    const expandedId = expandedConditionId ?? null;

    return (
        <ConditionsList>
            {conditions.map((condition) => (
                <ConditionCard
                    key={condition.id}
                    isDeleted={isDeleted}
                    isFocused={condition.id === focusId}
                    isExpanded={condition.id === expandedId}
                    data-condition-id={condition.id}
                    header={(open, isOpen) => renderHeader(condition, open, isOpen)}
                    onFileDrop={onFileDrop ? (files) => onFileDrop(condition, files) : undefined}
                >
                    {renderContent(condition)}
                </ConditionCard>
            ))}
        </ConditionsList>
    );
};
